<!--模板-->
<template>
  <div id="h5">
    <div class="h5_bg">
      <div class="h5_title">
        <p style="margin: 30px 0">
          <img src="../../../static/images/index/h5logo.png" alt="" />
        </p>
        <h1>玩乐之旅，总有陪伴在您身边~</h1>
        <h1>来认识附近1公里的Ta~</h1>
        <div class="app_img">
          <img src="../../../static/images/index/we.jpg" alt="" />
        </div>
        <h1>关注"陪伴玩"微信公众号</h1>
        <div class="down">
          <span @click="down(2)"
            ><span class="iconfont icon-xiaochengxu"></span>微信小程序</span
          >
          <span @click="down(0)"
            ><span class="iconfont icon-ios"></span>AppStore</span
          >
          <span @click="down(1)"
            ><span class="iconfont icon-anzhuo"></span>Android</span
          >
        </div>
        <h1>（下载APP，来认识附近1公里的Ta~）</h1>
        <h1 class="pc_btn">
          <span @click="$router.push('/?navigator=true')"
            ><span class="iconfont icon-diannao"></span>浏览电脑版网页</span
          >
        </h1>
        <div class="phoneImg">
          <img src="../../../static/images/index/phone_img.png" alt="" />
        </div>
        <!--        <div class="we_img">-->
        <!--          <span>-->
        <!--            <img src="../../../static/images/index/we.jpg" alt="">-->
        <!--            <p>微信小程序</p>-->
        <!--          </span>-->
        <!--          <span>-->
        <!--            <img src="../../../static/images/index/we.jpg" alt="">-->
        <!--            <p>微信公众号</p>-->
        <!--          </span>-->
        <!--          <span>-->
        <!--            <img src="../../../static/images/index/we.jpg" alt="">-->
        <!--            <p>微信订阅号</p>-->
        <!--          </span>-->
        <!--        </div>-->
        <div class="about">
          <!-- <p><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37089702000361" target=_blank>公网安备37089702000361号</a></p> -->
          <p>
            ©Copyright 2025 陪伴玩·
            <a href="http://www.beian.miit.gov.cn/" target="_blank"
              >鲁ICP备19036305号-2</a
            >
          </p>
        </div>
      </div>
      <el-dialog :visible.sync="centerDialogVisible" width="80%" center>
        <div class="wxImg">
          <img src="../../../static/images/index/wechat.jpg" alt="" />
          <p style="font-size: 40px">
            打开微信，扫描上方小程序码 <br />
            进入【陪伴玩】<span
              class="iconfont icon-xiaochengxu"
              style="font-size: 40px"
            ></span
            >微信小程序
          </p>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<!--JS-->
<script>
export default {
  data() {
    return {
      centerDialogVisible: false,
    };
  },
  methods: {
    down(index) {
      if (index == 0) {
        window.location.href = "https://apps.apple.com/cn/app/id1478709039";
      }
      if (index == 1) {
        window.location.href =
          "https://a.app.qq.com/o/simple.jsp?pkgname=com.peibanwan.app";
      }
      if (index == 2) {
        this.centerDialogVisible = true;
      }
    },
  },
};
</script>

<!--css样式-->
<style lang="scss" scoped>
@import "../../../src/scss/commonH5.scss";
.wxImg {
  width: 100%;
  text-align: center;
}
.down {
  margin: 20px 0;
  display: flex;
  justify-content: center;
  > span {
    color: #333;
    font-size: 40px;
    margin: 10px 20px;
    background: #fff;
    border-radius: 20px;
    padding: 10px 20px;
    span {
      font-size: 40px;
      padding-right: 5px;
    }
  }
}
.we_img {
  position: fixed;
  bottom: 100px;
  display: flex;
  justify-content: center;
  font-size: 30px;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  color: #fff;
  p {
    background: #000;
    display: inline-block;
    padding: 2px 16px;
    border-radius: 10px;
  }
  img {
    width: 200px;
    height: 200px;
    padding: 0 100px;
  }
}
.about {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 20px 0;
  text-align: center;
  font-size: 30px;
}
.pc_btn {
  margin-top: 50px;
  color: $fontColor;
  > span {
    color: #333;
    background: #fff;
    border-radius: 20px;
    padding: 10px 36px;
    display: inline-block;
    span {
      color: #333;
      font-size: 35px;
      padding-right: 20px;
    }
  }
}
.phoneImg {
  margin-top: 60px;
  img {
    border-radius: 15px;
  }
}
.app_img {
  margin: 60px 0;
  img {
    width: 300px;
    height: 300px;
    border-radius: 5px;
  }
}
.h5_title {
  text-align: center;
  margin-top: 60px;
  .title {
    font-size: 80px;
    text-align: center;
  }
}
#h5 {
  width: 100vw;
  color: #fff;
  background: $fontLinear;
  min-height: 100vh;
  position: fixed;
  z-index: 99999;
}
.h5_bg {
  position: fixed;
  width: 100vw;
  height: 150vh;
  top: 0;
  z-index: 999;
  /*background:#f60 url("../../../static/images/index/app_bg.jpg")no-repeat  50% 100%;*/
  background: $fontLinear;
  background-size: cover;
}
.h5_text {
  margin: 20px;
  padding: 20px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/h5/h5.vue